import React from 'react';
import ReactDOM from 'react-dom';
import './FileViewerModal.css';

const FileViewerModal = ({ isOpen, onClose, content, filename }) => {
    if (!isOpen) return null;

    const handleDownload = () => {
        const blob = new Blob([content], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    const modalContent = (
        <div className="file-viewer-modal-overlay" onClick={onClose}>
            <div className="file-viewer-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="file-viewer-modal-header">
                    <h3>{filename}</h3>
                    <div className="file-viewer-modal-actions">
                        <button onClick={handleDownload} className="btn-download">
                            📥 Download
                        </button>
                        <button onClick={onClose} className="btn-close">
                            ✕
                        </button>
                    </div>
                </div>
                <div className="file-viewer-modal-body">
                    <pre className="file-content">{content}</pre>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};

export default FileViewerModal;



